import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';

export const Services = () => {
  const navigate = useNavigate();

  const services = [
    {
      id: 1,
      title: "Promotion immobilière",
      description: "Développement de projets résidentiels sur mesure, de la conception à la livraison clés en main."
    },
    {
      id: 2,
      title: "Vente & Commercialisation",
      description: "Stratégie de commercialisation sur mesure avec marketing digital, visites 3D et réseau international."
    },
    {
      id: 3,
      title: "Achat de terrain & développement",
      description: "Identification des opportunités foncières et transformation en projets concrets et rentables."
    },
    {
      id: 4,
      title: "Construction & maîtrise d'ouvrage",
      description: "Pilotage complet de la construction avec maîtrise des coûts, délais et qualité d'exécution."
    },
    {
      id: 5,
      title: "Pilotage de projets de A à Z",
      description: "Accompagnement global pour investisseurs : planification, coordination et supervision complète."
    },
    {
      id: 6,
      title: "Gestion de projets de rénovation",
      description: "Modernisation et réhabilitation d'immeubles existants avec valorisation patrimoniale et énergétique."
    },
    {
      id: 7,
      title: "Location & Gérance immobilière",
      description: "Gestion complète de vos biens : location, maintenance, comptabilité et valorisation du patrimoine."
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e5a7a] mb-4">
            Nos Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-2">
            Spécialisé dans l'ensemble du cycle de vie immobilier
          </p>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            De l'acquisition du terrain jusqu'à la gestion locative, une approche cohérente, qualitative et durable.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {services.map((service, index) => (
            <Card
              key={service.id}
              className="group border-0 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer"
              style={{
                animationDelay: `${index * 100}ms`
              }}
            >
              <CardHeader className="pb-4">
                <CardTitle className="text-xl font-bold text-[#1e5a7a] group-hover:text-[#f5b800] transition-colors">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-700 leading-relaxed">
                  {service.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <Button
            onClick={() => navigate('/services')}
            size="lg"
            className="bg-[#1e5a7a] hover:bg-[#f5b800] hover:text-black text-white font-semibold px-8 py-6 text-lg transition-all duration-300 hover:scale-105 shadow-xl"
          >
            Découvrir tous nos services en détail
            <ArrowRight className="ml-2" size={20} />
          </Button>
        </div>
      </div>
    </section>
  );
};